import React, { useEffect, useState } from "react";
import Heading from "../../../component/Heading/Heading";
import TableComponent from "../../../component/Table/TableComponent";
import { getSubscription } from "../../../services/customer-services/customerBillingStatus";
import { TableCell, TableRow } from "@mui/material";
import { changeDateFormate } from "../../../helper/changeDateFormate";
import { useTranslation } from "react-i18next";
import { formatAmount } from "../../../helper/formatAmount";

const columns = [
    { field: "subscriptionNumber", headerName: "Subscription Number", translationKey: 'payment_history_subscription_number' },
    { field: "subscriptionName", headerName: "Subscription Name", translationKey: 'payment_history_subscription_name' },
    { field: "startDate", headerName: "Start Date", translationKey: 'client_list_start_date' },
    { field: "endDate", headerName: "End Date", translationKey: 'client_list_end_date' },
    { field: "nextPaymentDate", headerName: "Next Payment Date", translationKey: 'payment_history_next_payment_date' },
    { field: "amount", headerName: "Amount", translationKey: 'billing_amount' },
];

const Subscription = () => {
    const { t } = useTranslation();
    const [pageNo, setPageNo] = useState(1);
    const [perPage, setPerPage] = useState(25);
    const [totalRecords, setTotalRecords] = useState(0);
    const [subscriptionData, setSubscriptiondata] = useState([])

    const getAllSubscriptionData = async (payload) => {
        const response = await getSubscription(payload);
        setSubscriptiondata(response?.subscription);
        setTotalRecords(response?.totalRecords ? response?.totalRecords : 0)
    }

    useEffect(() => {
        getAllSubscriptionData({ perPage, perPage })
    }, [pageNo, perPage])

    return (
        <div className="payment-history">
            <div className="payment-history-sub-Heading">
                <Heading text={t('client_list_subscription')} className="payment-sub-heading" />
            </div>
            <TableComponent
                data={subscriptionData}
                setPageNo={setPageNo}
                pageNo={pageNo}
                perPage={perPage}
                setPerPage={setPerPage}
                totalRecords={totalRecords}
                columns={columns}
            >
                {
                    subscriptionData?.map((row, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell>{row.subscription.subscriptionNumber}</TableCell>
                                <TableCell>{row.subscription.planFrequency}</TableCell>
                                <TableCell>{changeDateFormate(row.subscription.subscriptionStartDate)}</TableCell>
                                <TableCell>{changeDateFormate(row.subscription.subscriptionEndDate)}</TableCell>
                                <TableCell>{row.subscription.planFrequency === "Free Trial" ? "-" : changeDateFormate(row.subscription.nextPaymentDate)}</TableCell>
                                <TableCell>{`${formatAmount(row.subscription.planPrice)} EUR`}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableComponent>
        </div>
    )
}

export default Subscription;